import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { translate } from '../../helpers/stringHelpers'
import { millisToLocaleString } from '../../helpers/dateHelpers'

const COUNTDOWN_CLASS_NAME = 'listing-card__countdown'

const toTwoDigits = (number) => number > 9 ? number : number.toString().padStart(2, '0')

const CountdownAuctionEnds = ({ completed, days, hours, minutes, seconds, isInOvertime, endsAt }) => {
  return completed
    ? (
      <span className={`${COUNTDOWN_CLASS_NAME} ${COUNTDOWN_CLASS_NAME}--complete`}>
        {translate('JspPublicCodes_JSP_SALE_ENDED_PENDING')}
      </span>
      )
    : !days
        ? (
        <span
          className={`${COUNTDOWN_CLASS_NAME}${!hours && minutes < 10
            ? ` ${COUNTDOWN_CLASS_NAME}--warning text-danger`
            : ''}`}
        >
          {translate(
            isInOvertime
              ? 'JspPublicCodes_JSP_SALE_OVERTIME_ENDS_IN'
              : 'JspPublicCodes_JSP_SALE_ENDS_IN'
          ).replace('{0}', `${toTwoDigits(hours)}:${toTwoDigits(minutes)}:${toTwoDigits(seconds)}`)}
        </span>
          )
        : (
        <span className={`${COUNTDOWN_CLASS_NAME} ${COUNTDOWN_CLASS_NAME}--date`}>
          {translate('JspPublicCodes_COUNTDOWN_ENDS')} {millisToLocaleString(endsAt)}
        </span>
          )
}

CountdownAuctionEnds.propTypes = {
  completed: PropTypes.bool.isRequired,
  days: PropTypes.number.isRequired,
  hours: PropTypes.number.isRequired,
  minutes: PropTypes.number.isRequired,
  seconds: PropTypes.number.isRequired,
  isInOvertime: PropTypes.bool.isRequired,
  endsAt: PropTypes.number.isRequired
}

export default memo(CountdownAuctionEnds)
